const API_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'] as const
const API_ROUTE_GROUPS = [
  'auth',
  'client',
  'clinic',
  'common',
  'doctor',
  'integrations',
  'media',
  'partner',
  'public',
  'shop',
] as const

type ApiMethod = typeof API_METHODS[number]
type ApiRouteGroup = typeof API_ROUTE_GROUPS[number] | 'other'

export function apiRouteGroup(requestUrl: string): ApiRouteGroup {
  const path = requestUrl
    .replace(/^[a-z][a-z\d+.-]*:\/\/[^/]+/i, '')
    .split(/[?#]/, 1)[0]
  const segments = path.split('/').filter(Boolean)
  const firstSegment = segments[0] === 'api' && segments[1] === 'v1'
    ? segments[2]
    : segments[0]

  return API_ROUTE_GROUPS.find((group) => group === firstSegment) ?? 'other'
}

export function apiErrorSentryTags(error: unknown): Record<string, string> {
  if (!error || typeof error !== 'object' || Array.isArray(error)) {
    return {}
  }

  const details = error as Record<string, unknown>
  if (details.name !== 'ApiError') {
    return {}
  }

  const method = API_METHODS.find((candidate) => candidate === details.apiMethod)
  if (!method) {
    return {}
  }

  const routeGroup = API_ROUTE_GROUPS.find((candidate) => candidate === details.apiRouteGroup) ?? 'other'
  const statusCode = Number.isInteger(details.statusCode)
    && Number(details.statusCode) >= 100
    && Number(details.statusCode) <= 599
    ? String(details.statusCode)
    : 'unknown'

  return {
    api_method: method,
    api_route_group: routeGroup,
    api_status_code: statusCode,
  }
}
